// =============================================================================
// UUID v4 generator (Portal)
// -----------------------------------------------------------------------------
// Used primarily for the Idempotency-Key header sent on mutating
// requests that the API treats as replayable (publish-to-shopify,
// spawn-product, and-product). The key is regenerated per logical
// user action — repeating the same request with the same key MUST
// return the previously cached response, while a new action MUST
// allocate a fresh key.
//
// We prefer crypto.randomUUID (universally available in modern
// browsers and Node.js 19+) and fall back to a Math.random-seeded
// variant only for unusual sandboxes (older WebViews, embedded JS
// engines). The fallback intentionally keeps the RFC 4122 v4 shape
// so the server-side validator can't tell the difference.
// =============================================================================

export function generateUuidV4(): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
